

import { Averages } from "../AveragesComputer";

import { DrawingService } from "../../Services/DrawingService";

import { BarPrice, LineData } from "lightweight-charts";
import { IndicatorDrawers } from "../IndicatorDrawers";
export class SmaPernamentWaveSet8 extends IndicatorDrawers {
  
  constructor(private _drawingService:DrawingService) { 
    super(_drawingService);
  };

  public range: number[] = [];
  public drawAction(canShow: boolean) 
  {
   // this._drawingService.smaBaseSerie=[]
   this._drawingService.smaBaseSerie.clear();
   
    if(canShow==false)
    {
      this.targetLineSerie.setData([]);
      return;
    }
    else
    {

      this.wavesAsSource = this.bindedWaveComputer.getAllWaves();

      if(this._drawingService.settingsService.diffValue==63)
      {
        this.wavesAsSource = this.bindedOverlayWaveComputer.getAllWaves();
      }
     

      let waves = this.wavesAsSource;


      var serie:LineData[] = [];
      waves.forEach(element => {
        serie.push({time:element.data[0].time, value:element.data[0].value})
      })


      this.smaBaseLineData = Averages.computeSma(serie, 8);

      let zigazg = this.bindedWaveComputer.zigZagSeriData


      this.targetLineSerie.setData(this.smaBaseLineData);

     // this._drawingService.smaBaseSerie = this.smaBaseLineData;
     this.smaBaseLineData.forEach(data => {
			this._drawingService.smaBaseSerie.set(data.time, data);
		});
      this.smaBase = Averages.averageOfAvailablePoints(serie,16);
       this._drawingService.smaBase = this.smaBase;
      // this.priceLine.applyOptions({
      //   price:this.smaBase as BarPrice
      // });


    }

  }


}
